"use client";

import gsap from "gsap";
import { type LenisRef, ReactLenis } from "lenis/react";
import {
  type PropsWithChildren,
  type ReactElement,
  useEffect,
  useRef,
} from "react";

export function LenisWrapper({
  children,
  root,
}: PropsWithChildren & { root?: boolean }): ReactElement {
  const lenisRef = useRef<LenisRef | null>(null);

  useEffect(() => {
    function update(time: number): void {
      lenisRef.current?.lenis?.raf(time * 1000);
    }

    gsap.ticker.add(update);

    return (): void => {
      gsap.ticker.remove(update);
    };
  }, []);

  return (
    <ReactLenis root={root} options={{ autoRaf: false }} ref={lenisRef}>
      {children}
    </ReactLenis>
  );
}
